import { render, staticRenderFns } from "./ApDetailCurve.vue?vue&type=template&id=252c38d0&"
import script from "./ApDetailCurve.vue?vue&type=script&lang=js&"
export * from "./ApDetailCurve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ApDetailCurve.vue"
export default component.exports